import { SITE } from "../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A192F] text-white pt-24 lg:pt-32 pb-12"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-6">
              Office of Sean Bledsoe
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Build healthcare
              <br />
              like it matters.
            </h2>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 px-7 py-4 bg-white text-[#0A192F] text-sm tracking-wide rounded-full hover:-translate-y-0.5 hover:shadow-2xl transition-all duration-300"
            >
              Reach the office
              <span aria-hidden>→</span>
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 text-white/80">
              <li><a href="#about" className="exec-link">Biography</a></li>
              <li><a href="#ventures" className="exec-link">Ventures</a></li>
              <li><a href="#digidoc" className="exec-link">DigiDoc</a></li>
              <li><a href="#projects" className="exec-link">Projects</a></li>
              <li><a href="#speaking" className="exec-link">Speaking</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-4">
              Elsewhere
            </div>
            <ul className="space-y-3 text-white/80">
              <li><a href={SITE.socials.linkedin} target="_blank" rel="noreferrer" className="exec-link">LinkedIn</a></li>
              <li><a href={SITE.socials.x} target="_blank" rel="noreferrer" className="exec-link">X / Twitter</a></li>
              <li><a href={SITE.socials.digidoc} target="_blank" rel="noreferrer" className="exec-link">DigiDoc</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-white/80">
              <li>sbledsoe1109@gmail.com</li>
              <li>United States · India</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Sean Bledsoe. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Press kit</a>
            <a href="#" className="hover:text-white">Disclosures</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
